import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import type { ComponentType } from 'react';

import BadgePercentIcon from '~/components/MarketplaceIcons/BadgePercentIcon';
import ShieldCheckIcon from '~/components/MarketplaceIcons/ShieldCheckIcon';

import styles from './ProductUspTiles.module.scss';

interface UspTileData {
  icon: ComponentType<{ className?: string }>;
  title: string;
  description: string;
}

const USP_TILES: UspTileData[] = [
  {
    icon: ShieldCheckIcon,
    title: 'Оригинальные товары',
    description: 'Абсолютно новый, в заводской упаковке',
  },
  {
    icon: BadgePercentIcon,
    title: 'Выгодные цены',
    description: 'Из безналоговой зоны аэропорта Дубая',
  },
];

/**
 * Trust-building USP pills shown on the DubaiExpress product page below the
 * price/CTA area: product originality guarantee and duty-free pricing.
 */
const ProductUspTiles = ({ className }: { className?: string }) => (
  <div className={classes([styles.root, className])}>
    {USP_TILES.map(({ icon: TileIcon, title, description }) => (
      <div key={title} className={styles.tile}>
        <TileIcon className={styles.icon} />
        <div className={styles.content}>
          <p className={styles.title}>{title}</p>
          <p className={styles.description}>{description}</p>
        </div>
      </div>
    ))}
  </div>
);

export default observer(ProductUspTiles);
